import { render, staticRenderFns } from "./recommend_item_comment.vue?vue&type=template&id=fa06745c&scoped=true&"
import script from "./recommend_item_comment.vue?vue&type=script&lang=ts&"
export * from "./recommend_item_comment.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_item_comment.vue?vue&type=style&index=0&id=fa06745c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa06745c",
  null
  
)

export default component.exports